import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { AdsService } from '../services/ads.service';

@Component({
  selector: 'app-detailedad',
  templateUrl: './detailedad.component.html',
  styleUrls: ['./detailedad.component.scss']
})
export class DetailedadComponent implements OnInit {

  public uploader: FileUploader = new FileUploader({});

  adDetails: any;
  adForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private adsService: AdsService) { }

  ngOnInit(): void {
   
    this.adDetails = JSON.parse(localStorage.getItem("adDetails"))
      console.log(this.adDetails)
      this.adForm = this.formBuilder.group({
        name: this.adDetails.name,
        description: this.adDetails.description,
        duration: this.adDetails.duration,
        country: this.adDetails.country,
        url: this.adDetails.url,
        img: [null]
        // img: ''
      });
  }
  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.adForm.patchValue({
      img: file
    });

    this.adForm.get('img').updateValueAndValidity();
  }

  modifyAd(){
    console.log("clicked")
    var formData: FormData = new FormData();
    var id = this.adDetails.id

    formData.append("name", this.adForm.get('name').value);
    formData.append("description", this.adForm.get('description').value);
    formData.append("url", this.adForm.get('url').value);
    formData.append("country", "123");
    formData.append("duration", this.adForm.get('duration').value);    
    formData.append("image", this.adForm.get('img').value);
          this.adsService.updateAd(id,formData).then((res: any) => {
            if(res.success){
              alert("Ad successfully updated")
            }
            console.log(res)
    })
      
  }

}
